import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import { getFirmAssetEntitlements } from './common';

const getFirmId = (_state: AdminState | ClientState, firmId: string) => firmId;

export const getFirmAssetEntitlementsByFirmId = createSelector(
    [ getFirmAssetEntitlements, getFirmId ],
    (allEntitlements, firmId) => {
        return Object.values(allEntitlements)
            .filter(entitlement => entitlement.FirmId === firmId && !entitlement.IsDeleted);
    }
);